import { Capacitor } from '@capacitor/core';
import { usePlatformContext } from '@/hooks/usePlatformContext';
import { openExternal } from '@/lib/openExternal';
import { cn } from '@/lib/utils';

const APP_STORE_URL = 'https://apps.apple.com/app/sabotage-fantasy/id6760446288';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.sabotagefantasy.app';

interface DownloadLinksProps {
  className?: string;
  badgeClassName?: string;
}

interface BadgeLinkProps {
  url: string;
  src: string;
  alt: string;
  badgeClassName?: string;
}

const BadgeLink = ({ url, src, alt, badgeClassName }: BadgeLinkProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (Capacitor.isNativePlatform()) {
      e.preventDefault();
      void openExternal(url);
    }
  };

  return (
    <a href={url} target="_blank" rel="noopener noreferrer" onClick={handleClick}>
      <img src={src} alt={alt} className={cn('h-11', badgeClassName)} />
    </a>
  );
};

export const DownloadLinks = ({ className, badgeClassName }: DownloadLinksProps) => {
  const { isIosApp, isAndroidApp, isWebBrowser } = usePlatformContext();

  if (isIosApp) return null;

  const showIos = isWebBrowser || isAndroidApp;
  const showAndroid = isWebBrowser;

  if (!showIos && !showAndroid) return null;

  return (
    <div className={cn('flex gap-4 flex-wrap justify-center items-center', className)}>
      {showIos && (
        <BadgeLink
          url={APP_STORE_URL}
          src="/badges/app-store-badge.svg"
          alt="Download on the App Store"
          badgeClassName={badgeClassName}
        />
      )}
      {showAndroid && (
        <BadgeLink
          url={PLAY_STORE_URL}
          src="/badges/google-play-badge.svg"
          alt="Get it on Google Play"
          badgeClassName={badgeClassName}
        />
      )}
    </div>
  );
};

export default DownloadLinks;
